import { z } from 'zod';
export const serviceRoleSchema = z.enum([
    'owner',
    'admin',
    'moderator',
    'support',
    'auditor',
    'user'
]);
export const profileUpdateSchema = z
    .object({
    displayName: z.string().trim().min(1).max(59),
    lastName: z.string().trim().max(59).nullable().optional(),
    bio: z.string().trim().max(400).nullable().optional(),
    avatarAttachmentId: z.string().cuid().nullable().optional()
})
    .strict();
export const privacyAudienceSchema = z.enum(['everyone', 'contacts', 'nobody']);
export const privacyUpdateSchema = z
    .object({
    messageAudience: privacyAudienceSchema.optional(),
    callAudience: privacyAudienceSchema.optional(),
    showLastSeen: z.boolean().optional(),
    safeMode: z.boolean().optional(),
    listedInDirectory: z.boolean().optional()
})
    .strict()
    .refine((value) => Object.keys(value).length > 0, 'Нет изменений');
/*
 * Пароль. Длину и прочие требования проверяет сервер общей функцией
 * checkPassword — здесь намеренно только форма запроса, чтобы правила
 * не разъезжались между клиентом и сервером.
 */
export const passwordChangeSchema = z
    .object({
    currentPassword: z.string().min(1).max(200),
    newPassword: z.string().min(1).max(200),
    code: z.string().trim().min(6).max(64).optional()
})
    .strict();
/** Запрос кода на возврат доступа. Принимается логин или внешняя почта. */
export const passwordResetRequestSchema = z
    .object({
    login: z.string().trim().min(1).max(200),
    captchaId: z.string().min(1),
    captchaNonce: z.string().min(1)
})
    .strict();
export const passwordResetConfirmSchema = z
    .object({
    login: z.string().trim().min(1).max(200),
    code: z.string().trim().min(1).max(12),
    newPassword: z.string().min(1).max(200)
})
    .strict();
/** Исправление внешней почты до завершения регистрации. */
export const verificationEmailChangeSchema = z
    .object({
    email: z.string().trim().min(1).max(254)
})
    .strict();
export const registrationUpdateSchema = z
    .object({
    login: z.string(),
    displayName: z.string().trim().min(1).max(59),
    email: z.string(),
    password: z.string().max(200).optional()
})
    .strict();
export const userSearchQuerySchema = z.object({
    q: z.string().trim().min(2).max(59),
    limit: z.coerce.number().int().positive().max(50).default(20)
});
export const userTargetSchema = z.object({ userId: z.string().cuid() }).strict();
/**
 * Своё имя контакта — как записан в телефонной книжке.
 *
 * Пустая строка равнозначна сбросу: человек стирает поле, чтобы снова видеть
 * настоящее имя собеседника, и отдельной кнопки «вернуть как было» для этого
 * заводить не нужно.
 */
export const contactRenameSchema = z
    .object({
    alias: z.string().trim().max(59),
    aliasLastName: z.string().trim().max(59)
})
    .strict();
export const sessionTargetSchema = z
    .object({ familyId: z.string().regex(/^[a-f0-9]{32}$/) })
    .strict();
/** Страница «Не в контактах»: сначала связанные, потом все остальные по имени. */
export const nonContactsQuerySchema = z.object({
    cursor: z.string().cuid().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    q: z.string().trim().max(59).optional()
});
//# sourceMappingURL=account.js.map